// import axios from "axios";
import router from "../router";


export default function auth({ next, store ,to }) {


  //اگر پلتفرم دسکتاپ باشد
  if(store.state.device=='Desktop') {
    setTimeout(() => {
      store.state.loading_site = false;
    }, 3500);
    store.dispatch("checkAuth");
    store.dispatch("check_optionSet");
    if(to.path=='/shop/home'||to.path=='/shop/shops'||to.path=='/shop/explore'||to.path=='/login'||to.path=='/'||to.path=='/shop'||to.path=='/desktop' 
	||to.path=='/shop/store-profile' ||to.path=='/shop/detail' ){
      return next();
    }

  }

  const token = localStorage.getItem("_token");
  if (!token) {
    router.push({ path: "/login" });
  } else {
    
    setTimeout(() => {
      store.state.loading_site = false;
    }, 3500);
    return next();
    
    // axios.post(store.getters.baseUrl + "/check-token",
    //     {},
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer " + store.getters.appToken,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     if (res.data.result == 1) {
    //       store.dispatch("checkAuth");
    //       store.dispatch("check_optionSet");
    //       setTimeout(() => {
    //         store.state.loading_site = false;
    //       }, 3500);
    //       return next();
    //     } else {
    //       localStorage.removeItem("auth");
    //       localStorage.removeItem("_token");
    //       let route = router.currentRoute._value.path;
    //       store.state.loading_site = false;
    //       if (route != "/login") router.push({ path: "/login" });
    //     }
    //   });
  }
}
